var _rect, _circle, _path, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 50,
    height: 56,
    rx: 4,
    fill: "#D7BDFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 23,
    r: 12,
    fill: "#AF7BFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7659 26.9683V26.4871C29.5612 26.3878 29.3628 26.2742 29.1721 26.1468C28.3508 25.598 27.7107 24.818 27.3327 23.9054C26.9547 22.9928 26.8558 21.9887 27.0485 21.0199C27.2412 20.0511 27.7168 19.1612 28.4153 18.4628C29.1137 17.7643 30.0036 17.2887 30.9724 17.096C31.9412 16.9033 32.9454 17.0022 33.8579 17.3802C34.7705 17.7582 35.5505 18.3983 36.0993 19.2196C36.648 20.0409 36.941 21.0065 36.941 21.9942C36.9395 23.3183 36.4129 24.5878 35.4766 25.5241C35.0819 25.9187 34.6281 26.2406 34.1359 26.481V26.9683C35.3745 27.3054 36.5282 27.9273 37.4996 28.7968C39.0252 30.1623 39.9937 32.0424 40.2198 34.0773C40.2324 34.1936 40.2205 34.3112 40.1847 34.4225C40.1489 34.5338 40.09 34.6363 40.0119 34.7233C39.9339 34.8103 39.8383 34.88 39.7316 34.9276C39.6248 34.9753 39.5092 34.9999 39.3923 34.9999H24.5096C24.3927 34.9999 24.2771 34.9753 24.1703 34.9276C24.0636 34.88 23.9681 34.8103 23.89 34.7233C23.8119 34.6363 23.7531 34.5338 23.7173 34.4225C23.6814 34.3112 23.6695 34.1936 23.6821 34.0773C23.9082 32.0424 24.8767 30.1623 26.4023 28.7968C27.3737 27.9273 28.5274 27.3054 29.7659 26.9683Z",
    fill: "#D7BDFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 40,
    width: 24,
    height: 4,
    rx: 2,
    fill: "#AF7BFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 48,
    width: 24,
    height: 4,
    rx: 2,
    fill: "#AF7BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounts);
export default __webpack_public_path__ + "static/media/Accounts.1c26f1e26d1bf97d7f452c82074de7f2.svg";
export { ForwardRef as ReactComponent };